import {combineReducers} from 'redux';

import context from './context';
import questionBank from './question-bank';
import questions from './questions';
import survey from './survey';
import surveys from './surveys';
import user from './user';

export default combineReducers({
    user,
    survey,
    surveys,
    context,
    questions,
    questionBank
});
